var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDownloadLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.6666H16V16H4V14.6666ZM10.6667 10.781L14.7141 6.73365L15.6569 7.67646L10 13.3333L4.34315 7.67646L5.28595 6.73365L9.33333 10.781V3.33331H10.6667V10.781Z",
    fill: "#FC6328"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download-line.04494dc7.svg";
export { ForwardRef as ReactComponent };